import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchIndustries = createAsyncThunk(
  "industries/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL || '/api'}/industries-hierarchy`);
      if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return {};
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message || "Failed to fetch industries");
    }
  },
  {
    condition: (params, { getState }) => {
      const { industries } = getState();
      if (industries.loading) {
        return false;
      }
      if (params?.force) {
        return true;
      }
      if (industries.fetched) {
        return false;
      }
    }
  }
);

const industrySlice = createSlice({
  name: "industries",
  initialState: {
    hierarchy: {},
    loading: false,
    error: null,
    fetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndustries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustries.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchy = action.payload;
        state.fetched = true;
      })
      .addCase(fetchIndustries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default industrySlice.reducer;
